import { IRecipient, MailParams } from '@dadohr/shared/domainTypes/mail';
import { CF } from '@dadohr/shared/versions';
import { callFirebaseFunction } from '../firebaseFunctions';

export const sendPreviewMail = (params: MailParams, recipient: IRecipient) => {
  return callFirebaseFunction<{
    mail: {
      html: string;
      subject: string;
    };
    sender: {
      from: { name?: string; email: string };
      replyTo: string;
    };
    recipient: {
      name?: string;
      email: string;
    };
  }>(CF.mail.sendPreviewMail, { params, recipient });
};

/**
 * @deprecated /This is not needed anymore since the resendExperienceItem adn resendMoment both do it now in the cf
 */
export const tryToRemoveEmailFromSuppressionList = async (email: string) => {
  try {
    await callFirebaseFunction('postmark-removeRecipientFromSuppression', {
      email
    });
  } catch (err) {
    console.log('Failed to remove email from suppression list', err);
  }
};
